import register from '../../../../global/js/registry';
export default register('o-product-info', () => import(/* webpackMode: "lazy" */ './o-product-info.controller'));
